export default __webpack_public_path__ + "static/media/review-person-2.71d23ef3.png";